module.exports = __webpack_public_path__ + "static/media/aa_stock_photo1.69c49549.jpg";